import { render, staticRenderFns } from "./FixedTab.vue?vue&type=template&id=abfe92aa&"
import script from "./FixedTab.vue?vue&type=script&lang=js&"
export * from "./FixedTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports